const getLastWordFromPath = (path: string): string => {
  const pathParts = path.split("/").filter((part) => part.trim() !== ""); // Filter out empty parts
  return pathParts[pathParts.length - 1]; // Return the last part of the path
};

export default getLastWordFromPath;
